import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Match from '../views/match.vue'
import ShezhenAndshemen from '../views/shezhenAndshemen.vue'
import JingongAndweixianjingong from '../views/jingongAndweixianjingong.vue'
import HuangpaiHongpaiJiaoqiu from '../views/huangpaiHongpaiJiaoqiu.vue'
import Kongqiulv from '../views/kongqiulv.vue'
import MatchHeatmap from '../views/matchHeatmap.vue'
import MarchHeatmpLive from '../views/marchHeatmpLive.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/match',
    name: 'Match',
    component: Match
  },
  {
    path: '/shezhen-anshemen',
    name: 'ShezhenAndshemen',
    component: ShezhenAndshemen
  },
  {
    path: '/jingong-weixianjingong',
    name: 'JingongAndweixianjingong',
    component: JingongAndweixianjingong
  },
  {
    path: '/huangpai-hongpai-jiaoqiu',
    name: 'HuangpaiHongpaiJiaoqiu',
    component: HuangpaiHongpaiJiaoqiu
  },
  {
    path: '/kongqiulv',
    name: 'Kongqiulv',
    component: Kongqiulv
  },
  {
    path: '/match-heatmap',
    name: 'MatchHeatmap',
    component: MatchHeatmap
  },
  {
    path: '/march-heatmp-live',
    name: 'MarchHeatmpLive',
    component: MarchHeatmpLive
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
